import { Container, CssBaseline, Stack, ThemeProvider, createTheme } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import React, { useEffect, useState } from 'react';


const columnOptions = {
    customBodyRender: val => <div style={{ width: "140px" }}>{ val }</div>
};
const columnOptionsLarge = {
    customBodyRender: val => <div style={{ width: "300px" }}>{ val }</div>
};
const textLabels = {
    body: {
        noMatch: "Ingresar datos",
        toolTip: "Ordenar",
        columnHeaderTooltip: column => `Ordenar por ${column.label}`
    },
      pagination: {
        next: "Página siguiente",
        previous: "Página anterior",
        rowsPerPage: "Renglones por página:",
        displayRows: "de",
    },
    toolbar: {
        search: "Buscar",
        downloadCsv: "Descargar CSV",
        print: "Imprimir",
        viewColumns: "Mostrar Columnas",
        filterTable: "Filtrar tabla",
    },
    filter: {
        all: "Todo",
        title: "FILTROS",
        reset: "RESETEAR",
    },
    viewColumns: {
      title: "Mostrar Columnas",
    //   titleAria: "Show/Hide Table Columns",
    },
};

const reportOptions = {
    print: false,
    search: false,
    filter: true,
    filterType: "dropdown",
    responsive: "standard",
    fixedHeader: true,
    fixedSelectColumn: false,
    tableBodyHeight: "460px",
    selectableRows: "none",
    rowsPerPage: 30,
    rowsPerPageOptions: [30, 60, 100],

    textLabels: textLabels,
};
const reportColumns = [
    { name: "registroReferencia",
        label: "Referencia",
        options: {
            filter: true,
            sort: true,
            setCellProps: () => ({
                style: {
                    whiteSpace: "nowrap",
                    position: "sticky",
                    left: "0",
                    background: "whitesmoke",
                    fontWeight: 600,
                    zIndex: 100,
                },
            }),
            setCellHeaderProps: () => ({
                style: {
                    whiteSpace: "nowrap",
                    position: "sticky",
                    left: 0,
                    background: "white",
                    fontWeight: 600,
                    textAlign: "center",
                    zIndex: 101,
                },
            }),
        },
    },
    { name: "partNombreCompleto", label: "Nombre Completo", options: columnOptions, },
    // { name: "partApellidoPaterno", label: "Apellido Paterno", options: columnOptions, },
    // { name: "partApellidoMaterno", label: "Apellido Materno", options: columnOptions, },
    { name: "trabModalidad", label: "Modalidad", options: columnOptions, },
    { name: "trabTitulo", label: "Título", options: columnOptionsLarge, },
    { name: "autores", label: "Autores", options: columnOptionsLarge, },
    { name: "trabOrientacion", label: "Orientación", options: columnOptions, },
    { name: "trabPalabrasClave", label: "Palabras Clave", options: columnOptions, },
];


export const ReporteDeTrabajos = ({ records }) => {
    // console.log({records});

    const [reportData, setReportData] = useState([]);


    const setAuthors = (authors) => {
        // console.log(authors);

        const strResult = authors.map( auth => {
            const nombres = auth.autorNombres.trim();
            const apellidos = auth.autorApellidos.trim();
            return `${ nombres } ${ apellidos }`;
        })

        return strResult.join(", ");
    }


    useEffect(() => {

        // Agrega al mismo elemento un objeto con el resultado del parse
        // records.map( item => item.trabajosObj = JSON.parse(item.trabajos) );

        const allWorks = [];
         
        // Recorremos todos los registros
        records.forEach( item => {
            // console.log({item});   
            const works = JSON.parse(item.trabajos);
            
            // Recorremos todos los trabajos
            works.forEach( work => {

                // console.log({work});
                // Insertamos el registro en reportData
                allWorks.push({
                    registroReferencia: item.registroReferencia,
                    partNombreCompleto: `${ item.partNombres } ${ item.partApellidoPaterno } ${ item.partApellidoMaterno }`,
                    trabModalidad: work.trabModalidad,
                    trabTitulo: work.trabTitulo,
                    trabOrientacion: work.trabOrientacion,
                    trabPalabrasClave: work.trabPalabrasClave,
                    autores: setAuthors(work.trabAutores), 
                    // autores: work.trabAutores.map( aut => `${ aut.autorNombres }-` ),
                })
            })
            
        })

        setReportData(allWorks);

    }, [ records ])
    
    
    return (
        <ThemeProvider theme={createTheme()}>
            <Container component="main" maxWidth="xl">
                <CssBaseline />

                    {/* <Box
                        sx={{
                            mt: 6,
                            mb: 8,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                        }}
                    > */}
                        <Stack direction="column" marginTop={ 1 }>
                            <MUIDataTable
                                title={ "" }
                                data={ reportData }
                                options={ reportOptions }
                                columns={ reportColumns }
                            />
                        </Stack>
                    {/* </Box> */}
            </Container>
        </ThemeProvider>
    )
}
  